export const LIGHT_COLOR_TYPE = 'light';
export const DARK_COLOR_TYPE = 'dark';
export const PRIMARY_COLOR_TYPE = 'primary';
export const SECONDARY_COLOR_TYPE = 'secondary';
export const INFO_COLOR_TYPE = 'info';
export const ERROR_COLOR_TYPE = 'error';
export const SUCCESS_COLOR_TYPE = 'success';
export const WARNING_COLOR_TYPE = 'warning';

// Canonical regex for custom scheme IDs.  Format: ws-custom-{colorType}-{id}
// where colorType is any lowercase letter sequence and id is one or more
// lowercase alphanumeric characters.
export const CUSTOM_SCHEME_ID_RE = /^ws-custom-([a-z]+)-([a-z0-9]+)$/;
// Matches default built-in scheme IDs: ws-{colorType}-{digit}
export const DEFAULT_SCHEME_ID_RE = /^ws-([a-z]+)-\d+$/;

export const DEFAULT_COLOR_SCHEMES = {
  'ws-dark-0': 'dark',
  'ws-dark-1': 'altDark',
  'ws-light-0': 'altLight',
  'ws-light-1': 'light',
  'ws-primary-0': 'primary',
  'ws-secondary-0': 'secondary',
};
